import "sweetalert";
import "./label_selector.js";

jQuery(function () {
  // BEHAVIOUR

  jQuery("body").on("click", "[data-component~=bulk-label-modal]", function (event) {
    event.preventDefault();
    new BulkLabelModal(jQuery(this).closest("form"));
  });

  // CLASSES

  function BulkLabelModal(form) {
    var toAdd = [];
    var toRemove = [];
    var containerSelector = "#bulk_label_modal";
    var newLabelLink = window.SparkleConfig.adminHtml.bulkLabelNewLink;
    var emptyLabelSelector = window.SparkleConfig.adminHtml.bulkLabelEmptySelector;
    var modalContent = '<div id="bulk_label_modal">' + newLabelLink + emptyLabelSelector + "</div>";

    showModal(modalContent);
    new LabelSelector(containerSelector, window.labels);

    // BEHAVIOUR

    jQuery(containerSelector).on("labelSelected", ".label", function (event, labelJSON) {
      cycleLabelState(this, labelJSON);
    });

    jQuery(containerSelector)
      .find(".add_new_label")
      .click(function () {
        sweetAlert.close();

        jQuery(containerSelector)
          .find(".add_new_label")
          .on("new-action-modal:success", function (event) {
            toAdd.push(event.originalEvent.detail.id);
            setLabelsIfConfirmed(true);
          });
      });

    // EVENT HANDLERS

    function setLabelsIfConfirmed(confirmed) {
      if (confirmed) {
        form.append(jQuery("<input>", { type: "hidden", name: "add_label_ids", value: toAdd }));
        form.append(jQuery("<input>", { type: "hidden", name: "remove_label_ids", value: toRemove }));
        form.trigger("submit");
      }
    }

    // HELPER FUNCTIONS

    function showModal(content) {
      var options = {
        title: "Label All",
        text: content,
        html: true,
        showCancelButton: true,
        confirmButtonText: "Apply Changes",
        closeOnConfirm: false,
        showLoaderOnConfirm: true,
      };
      swal(options, setLabelsIfConfirmed);
    }

    function cycleLabelState(label, labelJSON) {
      label = jQuery(label);

      if (label.is(".add")) {
        pull(labelJSON.id, toAdd);
        push(labelJSON.id, toRemove);
        label.toggleClass("add remove");
      } else if (label.is(".remove")) {
        pull(labelJSON.id, toRemove);
        label.removeClass("remove");
      } else {
        push(labelJSON.id, toAdd);
        label.addClass("add");
      }
    }

    function pull(id, list) {
      list.splice(list.indexOf(id), 1);
    }

    function push(id, list) {
      list.push(id);
    }
  }
});
